// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"da2b6415","141":"e3d8ceb4","270":"e4cee9c8","344":"086e4753","936":"413b9acd"}[chunkId] + ".chunk.js";
};